export const parseName = (name: string): string => {
  return name.split('<squad>')[0];
};
